export const APP_HEADER_ID = 'mednet-top-app-header'
